export default __webpack_public_path__ + "static/media/EventFlow.22cc32b7908c227670fcee548391feeb.webp";